import assertStatus from "@mittwald/api-client/dist/types/assertStatus";
import type { MittwaldApi } from "../../api/Mittwald";
import { mittwaldApi } from "../../api/Mittwald";

export type RelocationApiData =
  MittwaldApi.Paths.V2_Relocation.Post.Parameters.RequestBody;

export class Relocation {
  public readonly data: RelocationApiData;

  private constructor(data: RelocationApiData) {
    this.data = Object.freeze(data);
  }

  public static async create(values: RelocationApiData): Promise<void> {
    const priceTotal = values.prices.positions
      .map((position) => position.price)
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      .reduce((acc, curr) => acc + curr, 0);

    const response = await mittwaldApi.relocationCreateRelocation.request({
      header: {},
      requestBody: {
        ...values,
        prices: {
          ...values.prices,
          total: priceTotal,
        },
      },
    });

    assertStatus(response, 204);
  }
}
